import React from 'react';
import { Users, CheckCircle2, Activity, TrendingUp } from 'lucide-react';
import AdminStat from './AdminStat';

/**
 * AdminKpiAndCohort — top-of-page KPIs (4 stat cards) + the cohort
 * breakdown bar chart underneath. They share the same `stats` prop and
 * are visually grouped, so they live in one component. Pure
 * presentational — no state. Extracted from Admin.jsx.
 */
const AdminKpiAndCohort = ({ stats }) => (
  <>
    {/* Top-level KPIs */}
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-10">
      <AdminStat icon={Users} label="Total users" value={stats?.total_users ?? '—'} accent />
      <AdminStat icon={CheckCircle2} label="Onboarded" value={
        stats ? `${Math.round((stats.onboarding_rate || 0) * 100)}%` : '—'
      } sub={stats ? `${stats.onboarded_users}/${stats.total_users}` : null} />
      <AdminStat icon={Activity} label="Workouts logged" value={stats?.total_workouts ?? '—'} />
      <AdminStat icon={TrendingUp} label="Martial sessions" value={stats?.total_training_sessions ?? '—'} />
    </div>

    {/* Cohort breakdown */}
    <div className="bg-enf-surface-deep border border-enf-surface-border rounded-xl p-6 mb-10">
      <div className="flex items-center justify-between mb-5">
        <div className="text-sm font-semibold uppercase tracking-widest text-enf-text-secondary">Cohort breakdown</div>
        <span className="text-xs text-enf-text-muted">Source of every signup</span>
      </div>
      {!stats || stats.cohorts.length === 0 ? (
        <div className="text-sm text-enf-text-muted py-6 text-center">No signups yet.</div>
      ) : (
        <div className="space-y-3">
          {stats.cohorts.map((c) => {
            const pct = stats.total_users > 0 ? Math.round((c.count / stats.total_users) * 100) : 0;
            return (
              <div key={c.cohort} data-testid={`cohort-row-${c.cohort}`}>
                <div className="flex items-center justify-between mb-1.5">
                  <div className="text-sm font-semibold text-enf-text-primary capitalize">{c.cohort}</div>
                  <div className="text-xs text-enf-text-secondary"><span className="font-bold text-enf-text-primary">{c.count}</span> · {pct}%</div>
                </div>
                <div className="h-2 bg-enf-surface-mid rounded-full overflow-hidden">
                  <div className="h-full bg-enf-accent rounded-full transition-all duration-500" style={{ width: `${pct}%` }} />
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  </>
);

export default AdminKpiAndCohort;
